export const NewInputModule = ({type, id, placeholder, ...rest}) => {
	return (
		<input
			type={type}
			id={id}
			placeholder={placeholder}
			{...rest}
			onFocus={(e) => {
				e.target.style.borderColor = '#3676F5'
			}}
		/>
	)
}
// 3676F5
